import React from 'react';
import { connect } from 'react-redux';
import * as selectors from 'selectors/pathBuilder';
import EstimatedDuration from 'components/Learn/shared/LearnContentCard/EstimatedDuration';
import { withStatusModifier } from '../helpers';
import ContentWrapper from './Wrapper';
import Step from './Step';
import Status from './Status';

function MaximumAttemptsReached({
  status,
  formattedStatus,
  progress,
  urls,
  stepNumber,
  type,
  required,
  dateAdded,
  dueDate,
  isOverdue,
  id,
  ...props
}) {
  return (
    <ContentWrapper>
      <div className={`${withStatusModifier('PathContent', status)}`}>
        <div className="w-fill">
          <div className="PathContent-header">
            <h1 className="PathContent-title">{props.title}</h1>
            <Status
              {...{
                progress,
                status,
                formattedStatus,
                urls,
                required,
                dateAdded,
                dueDate,
                isOverdue,
              }}
              {...props}
            />
          </div>
          <div id="Notice-react-component-45f85e26-f682-4ff8-9333-c146d699fd17">
            <div className="Notice-Container d-f p-24 mb-16 Notice-Container--info CustomColor--backgroundColor">
              <div className="Notice-Sidebar mr-16">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  {/*<path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />*/}
                  {/*<rect x="8" y="2" width="8" height="4" rx="1" ry="1" />*/}
                  <circle cx="12" cy="12" r="10" />
                  <line x1="12" y1="8" x2="12" y2="12" />
                  <line x1="12" y1="16" x2="12.01" y2="16" />
                </svg>
              </div>
              <div className="info-well-body">
                <header className="mb-8 us-n">
                  <span className="llui-text llui-theme-text llui-text-body-bold llui-text-color-on-secondary">
                    {t('paths.dashboard.maximum_attempts_reached')}
                  </span>
                </header>
                <div className="us-n">
                  <span className="llui-text llui-theme-text llui-text-body llui-text-color-on-secondary">
                    {t('paths.dashboard.contact_for_reassignment')}
                  </span>
                </div>
              </div>
            </div>
          </div>
          {props.estimatedMinutesToComplete && (
            <div className="ml-24 pb-16">
              <EstimatedDuration
                estimatedMinutesToComplete={props.estimatedMinutesToComplete}
              />
            </div>
          )}
          <Step {...{ stepNumber, status, progress, id }} />
        </div>
      </div>
    </ContentWrapper>
  );
}

function mapStateToProps() {
  const getStepNumber = selectors.getStepNumber();
  return (state, props) => ({
    stepNumber: getStepNumber(state.pathViewer, props),
  });
}

export default connect(mapStateToProps)(MaximumAttemptsReached);
